import { IconComponent } from './types';

const LockIcon: IconComponent = (props) => (
  <svg
    width={8}
    height={11}
    viewBox="0 0 8 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 8.5c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1ZM7 4h-.5V3a2.5 2.5 0 0 0-5 0v1H1c-.55 0-1 .45-1 1v5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1ZM2.45 3c0-.855.695-1.55 1.55-1.55.855 0 1.55.695 1.55 1.55v1h-3.1V3ZM7 10H1V5h6v5Z"
      fill="currentColor"
    />
  </svg>
);

export default LockIcon;
